function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Children } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
import { Container } from "../Container/index.js";
const barClasses = cva([
    'bg-primary-50',
    'h-12',
    'lg:h-16',
    'overflow-x-auto',
    'overflow-y-hidden'
], {
    variants: {
        sticky: {
            true: [
                'z-[5]',
                'sticky',
                'top-16'
            ],
            false: []
        }
    }
});
const containerClasses = cva([
    'flex',
    'flex-row',
    'flex-nowrap',
    'overflow-x-visible',
    'h-full',
    'snap-x',
    'snap-mandatory',
    'justify-start',
    'items-center'
], {
    variants: {
        alignment: {
            center: [
                'lg:justify-center'
            ],
            start: []
        }
    }
});
/**
 * Nav Bar - [API](https://scl.sharp.com/?path=/docs/components-navbar) | [DSM](https://sharphealthcare.notion.site/Nav-bar-block-6539fc3170b34389b3ba1979c9043bfe)
 */ const NavBar = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { alignment = 'start', sticky = false, className, children, rightElement, slotProps = {} } = _param, props = _object_without_properties(_param, [
        "alignment",
        "sticky",
        "className",
        "children",
        "rightElement",
        "slotProps"
    ]);
    var _slotProps_rightElementContainer;
    const _ref = (_slotProps_rightElementContainer = slotProps.rightElementContainer) !== null && _slotProps_rightElementContainer !== void 0 ? _slotProps_rightElementContainer : {}, { className: rightElementClassName } = _ref, restOfRightElementProps = _object_without_properties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("nav", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: cn(barClasses({
            sticky,
            className
        })),
        children: /*#__PURE__*/ _jsxs(Container, {
            as: "ul",
            className: cn(containerClasses({
                alignment
            })),
            children: [
                Children.map(children, (child)=>/*#__PURE__*/ _jsx("li", {
                        className: "first:-ml-5 first:xl:-ml-8 shrink-0 snap-center [&>*]:px-5 xl:[&>*]:px-8 [&>*]:py-2.5 lg:[&>*]:py-4",
                        children: child
                    })),
                rightElement && /*#__PURE__*/ _jsx("li", _object_spread_props(_object_spread({
                    className: `ml-auto ${rightElementClassName}`
                }, restOfRightElementProps), {
                    children: rightElement
                }))
            ]
        })
    }));
});
export { NavBar };
